export interface Config {
  apiUrl: string;
  clarityEnabled: boolean;
  clarityProjectId: string;
  googleAnalyticsEnabled: boolean;
  googleAnalyticsMeasurementId: string;
  introEnabled: boolean;
  landingUrl: string;
  testModeEnabled: boolean;
  uiVersion: string;
}

export type ErrorCode = '0028';

export enum SuccessCode {
  ResetPassword = 'reset-password',
  Subscribe = 'subscribe',
}

export type ApiResponseBodyError = {
  data: null;
  message: string;
  status: 'error';
  statusCode: `${number}${number}${number}${number}`;
};

export type ApiResponseBodySuccess<Data = null> = {
  data: Data;
  message: string;
  status: 'success';
  statusCode: `${number}${number}${number}${number}`;
};

export type ApiResponseBody<Data = null> = ApiResponseBodyError | ApiResponseBodySuccess<Data>;

export interface Invoice {
  id: string;
  created: string | number;
  platform: string;
  total: number;
  currency?: string | null;
  status: string;
  lines: {id: string; description: string}[];
}

export interface IdentitySettings {
  showSamples: boolean;
}

export enum MatchMode {
  Prefix,
  Suffix,
  Contains,
  Exact,
  Regex,
  Similarity,
}

export enum OrderDirection {
  Ascending = 0,
  Descending = 1,
}

export enum DeliveryMethod {
  Email = 1,
  SMS = 2,
}
